import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Modal } from '../../Modal.es.js';
import { FullScreenHeader } from './FullScreen.Header/FullScreen.Header.es.js';
import { FullScreenProgressBar } from './FullScreen.ProgressBar/FullScreen.ProgressBar.es.js';

/**
 * Full Screen Modal Layout.
 */ const FullScreen = ({ variant = 'stretch', children, className, stepIndex = 0, totalSteps = 0, hideHeader = false, hideProgressBar = false, onCloseClick, ...props })=>{
    return jsx("div", {
        className: classNames('cb-modal-layout-fullscreen', variant),
        ...props,
        children: jsxs("div", {
            className: classNames('header', variant),
            children: [
                jsxs("div", {
                    className: classNames('header-progress', {
                        'progress-hidden': hideProgressBar
                    }),
                    children: [
                        hideHeader ? null : jsx(FullScreenHeader, {
                            onCloseClick: onCloseClick
                        }),
                        hideProgressBar ? null : jsx(FullScreenProgressBar, {
                            stepIndex: stepIndex,
                            totalSteps: totalSteps ?? 0
                        })
                    ]
                }),
                jsx(Modal.Body, {
                    className: classNames('body', className),
                    children: variant === 'stretch' ? jsx("div", {
                        children: children
                    }) : children
                })
            ]
        })
    });
};
FullScreen.displayName = 'Modal.Layout.FullScreen';

export { FullScreen, FullScreen as default };
//# sourceMappingURL=FullScreen.es.js.map
